export default __webpack_public_path__ + "static/media/android.9385089f.svg";